// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"770":"bc470c9a3de353267813","951":"2dc6d9fece4b9d24b349"}[chunkId] + ".css";
};